import "../chunk-D57E6H3M.mjs";

// src/utils/isImeComposing.ts
function isImeComposing(event) {
  return event.isComposing || event.keyCode === 229;
}
export {
  isImeComposing
};
//# sourceMappingURL=isImeComposing.mjs.map